define('modules/lp_info/views/variant_history_chart',['require','exports','module','base/itemview','underscore','backbone','highcharts','highcharts-theme','highcharts-module'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview"),
      _ = require("underscore"),
      Backbone = require("backbone");

  require("highcharts");
  require("highcharts-theme");
  require("highcharts-module");

  var dateUtils = {
    startOfToday: function() {
      var now = _.now();
    }
  };

  module.exports = ItemView.extend({
    noTemplate: true,

    initialize: function(options) {
      this.viewModel = new Backbone.Model();
      options.collection.on("sync", this.redraw, this);
      // maybe the line below is useless now
      this.listenTo(this.collection, "add refresh", this.refresh);
      this.i18n = {
        chartTitle: $.i18n.t("landingPage.chart.title"),
        xAxisTitle: $.i18n.t("landingPage.chart.xAxisTitle"),
        yAxisTitle: $.i18n.t("landingPage.chart.yAxisTitle"),
        tooltipFormat: $.i18n.t("landingPage.chart.tooltipFormat"),
      };
    },

    onShow: function () {
      setTimeout(this.redraw.bind(this), 0);
    },

    getChartData: function() {
      return _.map(this.collection.where({active: true}), function(variant) {
        return {
          name: variant.get("name") || "variant",
          data: this._parseChartData(variant.get("history"))
        };
      }, this);
    },

    getChartOptions: function() {
      var anyHistory = this.collection.at(0).get("history"),
          title = this.i18n.chartTitle.replace("{0}", anyHistory.length);

      return {
        chart: {
          width: 1216
        },
        title: { text: title },
        // tooltip: {
        //   formatter: function() {
        //       return "Visits: " + this.visits + "<br />Conversions: " + this.conversions;
        //   }
        // },
        yAxis: {
          title: { text: this.i18n.yAxisTitle },
          allowDecimals: true
        },
        xAxis: {
          title: {text: this.i18n.xAxisTitle },
          type: "datetime",
          dateTimeLabelFormats: {
            day: "%e/%m"
          },
          allowDecimals: false
        },
        series: this.getChartData()
      };
    },

    refresh: _.debounce(function() {
      //this.$el.highcharts({series: this.getChartData()});
      this.redraw();
    }, 100),

    redraw: function() {
      if (this.collection.size()) {
        this.$el.highcharts(this.getChartOptions());
      }
      return this;
    },

    _parseChartData: function(history){
      var firstDate = this.collection.getInitDate();
      //history contains {  visits, visitors, conversion, crt}
      return _.map(history, function(value, index){
        //return a hightchart configuration object
        var date = new Date(firstDate);
        date.setDate(firstDate.getDate()+index);
        var tooltip = this.i18n.tooltipFormat;
        tooltip = tooltip.replace("{0}", value.visitors);
        tooltip = tooltip.replace("{1}", value.visits);
        tooltip = tooltip.replace("{2}", value.conversion);
        tooltip = tooltip.replace("{3}", value.crt.toFixed(2) + "%");
        tooltip = tooltip.replace("{4}", date.toLocaleDateString());
        return {
          name: tooltip,
          y: parseFloat(value.crt.toFixed(2)),
          x: date
        };
      }, this);
    }
  });

});

